import * as actions from './actions';
import reducers from './reducer';

export const Comments = { actions, reducers };
export { CommentState } from './reducer';
